// extracted by mini-css-extract-plugin
export var addToCartButton = "_sn-b";
export var arrowButtonContainer = "_sn-9";
export var arrowButtonIcon = "_sn-a";
export var carouselArrowButton = "_sn-6";
export var carouselElementContainer = "_sn-1";
export var galleryThumbnail = "_sn-d";
export var galleryThumbnailImage = "_sn-e";
export var left = "_sn-7";
export var productDisplayCarouselContainer = "_sn-0";
export var productTileContainer = "_sn-2";
export var productTileImage = "_sn-4";
export var productTileImageContainer = "_sn-3";
export var productTileTitle = "_sn-5";
export var right = "_sn-8";
export var sliderOverflow = "_sn-c";